const paragraph = (param) => {
    return `<p>${param}</p>`
}
module.exports = paragraph